/**
 * @file 絞り込み保存
 */
'use strict';

import Cookies from 'js-cookie';

/**
 * @classname SavedApplyFilter
 * @classdesc 絞り込み保存
 */
export default class SavedApplyFilter {
	/**
	 * @constructor
	 * @param {jQuery} $e - #saved-filter
	 */
	constructor($e) {
		console.log('SavedApplyFilter.constructor');
		this._$e = $e;
		this._pageId = $e.attr('data-page');
		let optionArray = [];
		$('.main-affiliation').each((idx, e) => {
			const $e = $(e);
			const affiliation = $e.text();
			optionArray.push(affiliation);
		})
		optionArray = [...new Set(optionArray)];
		let options = '<option value="" selected>すべて</option>';
		for (let i = 0; i < optionArray.length; i++) {
			if (optionArray[i] === '-') {
				options += `<option value="-">非加盟員</option>`;
			} else {
				options += `<option value="${optionArray[i]}">${optionArray[i]}</option>`;
			}
		}
		this._$e.html(options);
		$e.on('change', () => this.onChange());
		this._savedValue = Cookies.get('saved-apply-filter') || null;
		if(this._savedValue) this._savedValue = JSON.parse(this._savedValue);
		console.log(this._savedValue);
		if(this._savedValue && this._savedValue.length > 0) {
			for(let i = 0; i < this._savedValue.length; i++) {
				const savedValueArr = this._savedValue[i].split('=');
				if(savedValueArr[0] === this._pageId) {
					console.log(savedValueArr[0], this._pageId);
					$e.val(savedValueArr[1]);
					this.onChange();
				}
			}
		}
	};


	/**
	 * changeのコールバック
	 *
	 * @memberof SavedApplyFilter
	 * @return {undefined}
	 */
	onChange() {
		console.log('SavedApplyFilter.onChange');
		const value = this._$e.val();
		const $tr = $('.member-apply-list .tbody .tr');
		$tr.show();
		if (value !== '') {
			$tr.each((idx, e) => {
				const $e = $(e);
				const text = $e.find('.main-affiliation').text();
				if (text !== value) {
					$e.hide();
				}
			})
		}
		const page = `${this._pageId}=${value}`;
		let newSavedValueArr = [];
		if(!this._savedValue) {
			newSavedValueArr.push(page);
		} else {
			console.log('cookieにある');
			let sameFlg = false;
			for(let i = 0; i < this._savedValue.length; i++) {
				console.log(this._savedValue[i]);
				const savedValueArr = this._savedValue[i].split('=');
				if (savedValueArr[0] === this._pageId) {
					// 重複するページがあるなら上書き
					newSavedValueArr.push(page)
					sameFlg = true;
				} else {
					newSavedValueArr.push(this._savedValue[i])
				}
			}
			// 重複するページがなければ追加
			if(!sameFlg) newSavedValueArr.push(page);
		}
		this.saveValue(newSavedValueArr);
	};


	/**
	 * 値の保存
	 *
	 * @memberof SavedApplyFilter
	 * @return {undefined}
	 */
	saveValue(value = null) {
		console.log('SavedApplyFilter.saveValue');
		console.log(value);
		if(value.length === 0) {
			Cookies.remove('saved-apply-filter');
		} else {
			value = JSON.stringify(value);
			Cookies.set('saved-apply-filter', value);
		}
	};
}